import { dailySessionNotes } from '../../actions/constant';

const {
  GET_DAILY_SESSION_NOTES_FAILURE,
  GET_DAILY_SESSION_NOTES_SUCCESS,
  GET_DAILY_SESSION_NOTES_LOADING,
  GET_DAILY_SESSION_NOTES_RESET,
  GET_DAILY_SESSION_NOTES_REQUEST,
} = dailySessionNotes;

const intitialstate: object = {
  response: null,
  isError: false,
  errorMessage: '',
  loading: false,
};

export const getDailySessionNotes = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_DAILY_SESSION_NOTES_SUCCESS: {
      return {
        ...state,
        isError: false,
        response: action.payload?.data,
        loading: false,
      };
    }

    case GET_DAILY_SESSION_NOTES_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };
    case GET_DAILY_SESSION_NOTES_LOADING:
    case GET_DAILY_SESSION_NOTES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_DAILY_SESSION_NOTES_RESET:
      return {
        ...state,
        response: null,
        isError: false,
        errorMessage: '',
      };
    default:
      return state;
  }
};
